var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',[_c('a',{attrs:{"href":"https://github.com/shiori2024/todolist/tree/vue2","target":"_blank"}},[_vm._v("源代码")]),_vm._v("  ©"+_vm._s(_vm.nowTime)+" "),_c('a',{attrs:{"href":"https://github.com/shiori2024","target":"_blank"}},[_vm._v("shiori2024")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }